import {
    AfterViewInit,
    Component,
    Input,
    NgZone,
    OnInit,
    ViewChild,
    ChangeDetectorRef,
    AfterViewChecked,
    Output, EventEmitter, SimpleChange
} from '@angular/core';
import loadGoogleMapsApi = require('load-google-maps-api');
import {BehaviorSubject} from "rxjs";
import {Subject} from "rxjs/Subject";
import {TranslateService} from "@ngx-translate/core";
import {GeoCodeService} from "../../../../core/geo-code.service";
import {PointOfSaleServiceA2} from "../../point-of-sale.service";
import {GeoServiceA2} from "../../../../core/geo_a2.service";
import {LoggerService} from "../../../../core/logger.service";
import {PointOfSaleDto} from "../../point-of-sale-dto";
import MapOptions = google.maps.MapOptions;
import {DestinationTypeEnum} from "../../destination-type.enum";
import {MeetingTypeEnum} from "../../meeting-type.enum";
import {AirportCodeEnum} from "../../airport-code.enum";

@Component({
    selector: 'office-location',
    templateUrl: './office-location.component.html',
    providers: [PointOfSaleServiceA2, GeoCodeService]
})
export class OfficeLocationComponent implements OnInit, AfterViewInit, AfterViewChecked{

    @ViewChild('map') gmapElement: any;
    @ViewChild('pickupCity') autocomplete: any = {};
    map: google.maps.Map;
    locations:any;
    private noPoi:MapOptions={styles: [{featureType: "poi",stylers: [{ visibility: "off" }]}]};
    marker:any;
    geolocation:any = {lat:'', lng:''};
    warningOn:boolean=false;
    @Input() subject:Subject<any>;
    @Input() dto:PointOfSaleDto;
    @Input() isEditing:boolean = false;
    @Input() errors;
    @Input() errorMessages;
    @Input() posSelected;
    @Input() isValid;
    @Input() errorKey;
    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
    showError:boolean=false;


    constructor(private  zone: NgZone, private geoCodeService:GeoCodeService, private geoService:GeoServiceA2,
                private logger: LoggerService, private translate: TranslateService,
                private cdRef:ChangeDetectorRef) {
        logger.info('PointOfSaleEditComponent: logger.info()');
    }

    ngAfterViewChecked(){
        this.cdRef.detectChanges();
    }

    ngOnChanges(changes:  {[propKey: string]: SimpleChange}): void {
        let errorsFromParent = changes['isValid'];
        if(errorsFromParent) {
            this.showError = !errorsFromParent.currentValue;
        }
    }

    ngAfterViewInit(): void {
        loadGoogleMapsApi({client:(<any>window).mapsClientId}).then((googleMaps) => {
            this.logger.info(`Loading google maps api`);
            let mapProp = {
                center: new google.maps.LatLng(40.294163, -3.7581804000000147),
                zoom: 8,
                streetViewControl: false,
                mapTypeControl: false,
                panControl: false,
                scaleControl: false,
                navigationControl: false,
                disableDoubleClickZoom: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 8,
                maxZoom: 15
            };
            this.map = new googleMaps.Map(this.gmapElement.nativeElement, mapProp);
            this.map.setOptions(this.noPoi);
            if(this.isEditing){
                this.onSelect.emit({locationOid:this.dto.locationOid, destinationType:this.dto.destinationType})
                this.logger.info(`Has initial position`);
                //If geolocation has beean loaded
                if(!!this.dto.geoLocation.latitude && !!this.dto.geoLocation.longitude){
                    let locationPromise = new Promise((resolve, reject) => {
                        if(!!this.autocomplete.nativeElement.componentDidLoad){
                            resolve("¡Éxito!");
                        }else{
                            this.autocomplete.nativeElement.addEventListener("componentDidLoad", ()=>{
                                resolve("¡Éxito!");
                            });
                        }
                    });
                    locationPromise.then((successMessage) => {
                        this.autocomplete.nativeElement.selectInputValue(this.dto.locationName);
                    });

                    //TODO: Fix for firefox..
                    this.autocomplete.nativeElement.selectInputValue(this.dto.locationName)
                    this.locate({lat:this.dto.geoLocation.latitude, lng:this.dto.geoLocation.longitude});
                }else{
                    //Geolocation hasnt been loaded yet, so keep listening subscription
                    this.subject.subscribe((val) => {
                        this.locate({lat:val.geoLocation.latitude, lng:val.geoLocation.longitude});
                    });
                }
            }
        }).catch((error) =>{
            this.logger.error(`Google api coult not be loadded`, error);
        });


    }

    ngOnInit(): void {
        this.logger.info(`Location :: ${JSON.stringify(this.dto.locationName)} - ${JSON.stringify(this.dto.geoLocation)}`);
        this.subject = new BehaviorSubject(this.dto);
    }


    addMapMarker(){
        if(!!this.marker){
            this.marker.setMap(null);
        }
        if(this.dto.destinationType==DestinationTypeEnum.AIRPORT){
            this.dto.geoLocation = {latitude:this.geolocation.lat.toFixed(6), longitude:this.geolocation.lng.toFixed(6)};
            this.locate(this.geolocation);
        }else{
            this.geoCodeService.getLocations(this.dto.street + "," + this.dto.locationName).subscribe((results) => {
                let latLng = results[0].geometry.location;
                this.dto.geoLocation = {latitude:latLng.lat().toFixed(6), longitude:latLng.lng().toFixed(6)};
                this.locate(latLng);
            });
        }
    }

    locate(point){
        this.logger.info(`Ceate new marker with position defined ${JSON.stringify(point)}`);

        //Create new marker with position defined
        this.marker = new google.maps.Marker({
            map: this.map,
            position: point,
            draggable: (this.dto.destinationType!=DestinationTypeEnum.AIRPORT)
        });
        //Keep listening drag event in order to update street after moving marker
        google.maps.event.addListener(this.marker, "dragend", (event) => {
            this.dto.geoLocation = {latitude:event.latLng.lat().toFixed(6), longitude:event.latLng.lng().toFixed(6)};
            this.marker.setAnimation(4);
            this.updateStreet();
        });
        this.map.setCenter(point);
        this.map.setZoom(15);
    }

    updateStreet(){
        this.zone.runOutsideAngular(() => {
            let address = "";
            this.geoCodeService.geocode({ latLng: this.marker.position }, (responses) => {
                if (responses && responses.length > 0) {
                    address = responses[0].formatted_address.split(',')[0];
                    this.zone.run(() => {
                        this.dto.street =  address;
                    });
                }
            });
        });
    }

    searchLocations(event){
        let language = this.translate.currentLang;
        if(event.detail.length > 2){
            this.logger.info(`Searching location for: ${event.detail}`);
            this.geoService.getAirportsAndCities(event.detail, language).subscribe(result => {
                this.locations = result;
            })
        }else{
            this.logger.info(`location length should be bigger than 2`);
        }
    }

    itemSelected(item){
        this.logger.info(`Item selected: ${JSON.stringify(item)}`);
        this.dto.locationOid = item.oid;
        this.dto.locationName = item.name;
        this.dto.street = '';

        if(item.typeReference == DestinationTypeEnum.AIRPORT){
            this.dto.destinationType = item.typeReference;
            this.dto.destinationTypeValue = this.translate.instant("pointOfSale.destinationType."+item.typeReference);
            this.geolocation.lat = item.location.latitude;
            this.geolocation.lng = item.location.longitude;

            if(this.dto.pickupIndications && this.isSpecialAirport(this.dto.locationOid) && this.dto.pickupIndications.meetingType !== "COUNTER") {
                this.dto.pickupIndications.additionalInstructions = "";
                this.dto.pickupIndications.meetingType = "";
            }

        } else if(item.typeReference == 'C') {
            this.dto.destinationType = DestinationTypeEnum.CITY;
            this.dto.destinationTypeValue = this.translate.instant("pointOfSale.destinationType.CITY");

            if(this.dto.pickupIndications) {
                this.dto.pickupIndications.additionalInstructions="";
                this.dto.pickupIndications.meetingType = MeetingTypeEnum.COUNTER;
            }
        }else{
           this.dto.pickupIndications.meetingType=null;
       }
        this.onSelect.emit({locationOid:item.oid, destinationType:item.typeReference})
        this.addMapMarker();
    }

    isSpecialAirport(locationOid):boolean {
        return (locationOid == AirportCodeEnum.MIAMI_AIRPORT
            || locationOid == AirportCodeEnum.CANCUN_AIRPORT
            || locationOid == AirportCodeEnum.ORLANDO_AIRPORT);
    }

    setWarning() {
        this.warningOn = true;
        setTimeout(function () {
            this.warningOn = false;
        }, 6000);
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/edit/office-location/office-location.component.ts